<template>
        <v-menu v-model="timePicker" :close-on-content-click="false">
            <template v-slot:activator="{ props }">
                <v-text-field
                    :data-cy="`${dataCyPrefix}-time`"
                    v-model="formattedTime"
                    :label="$t('formFields.timeInterval')"
                    readonly
                    v-bind="props"
                    hide-details="auto"
                />
            </template>
            <v-card>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-time-picker
                                v-model="modelValue.timeStart"
                                format="24hr"
                                scrollable
                                :title="$t('formFields.selectStartTime')"
                                @update:modelValue="updateTime('timeStart', $event)"
                            />
                        </v-col>
                        <v-col>
                            <v-time-picker
                                v-model="modelValue.timeEnd"
                                format="24hr"
                                scrollable
                                :title="$t('formFields.selectEndTime')"
                                @update:modelValue="updateTime('timeEnd', $event)"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-menu>
</template>

<script>
export default {
    props: {
        modelValue: Object,
        dataCyPrefix: String,
    },
    emits: ["update:modelValue"],
    data() {
        return {
            timePicker: false,
        };
    },
    computed: {
        formattedTime() {
            return this.modelValue.timeStart && this.modelValue.timeEnd
                ? `${this.modelValue.timeStart} - ${this.modelValue.timeEnd}`
                : "";
        },
    },
    methods: {
        updateTime(field, value) {
            this.$emit("update:modelValue", {
                ...this.modelValue,
                [field]: value,
            });
            if (this.modelValue.timeStart && this.modelValue.timeEnd) {
                this.$nextTick(() => {
                    this.timePicker = false;
                });
            }
        },
    },
};
</script>
